import React from "react";
import "./index.css";

export const WhyThisMatters = () => {
  return (
     <div className="why-this-matter-section">
      <div className="why-this-matter-section-heading">Why This Matters?</div>
      <div className="why-this-matter-section-desc">
        People don’t always need advice. They need to be heard. Become someone
        who listens with heart — No judgement, just presence.
      </div>

      {/* Cards Grid */}
      <div className="why-this-matter-grid">
        <div className="why-this-matter-card">
          <h3>Make a Difference</h3>
          <p>Support people worldwide by simply listening.</p>
        </div>

        <div className="why-this-matter-card">
          <h3>Flexible & Remote</h3>
          <p>Be available on your own schedule.</p>
        </div>

        <div className="why-this-matter-card">
          <h3>Training Provided</h3>
          <p>4 weeks of training will be provided with certification.</p>
        </div>

        <div className="why-this-matter-card">
          <h3>Personal Growth</h3>
          <p>Build empathy, patience, and communication skills.</p>
        </div>
      </div>

      {/* Button */}
      <div className="why-this-matter-button-wrapper">
        <a href={`${process.env.REACT_APP_LISTENAURA_APP_URL}`} target="_blank"> <button>Start Your Session</button></a>
      </div>
    </div>
  );
};
